module.exports = __webpack_public_path__ + "img/business-and-finance.51fb3306.svg";